/**
 * @file 處理時間格式轉換，依賴 date-fns
 * @requires date-fns {@link https://date-fns.org/docs/}
 */

import format from 'date-fns/format'
import formatDistance from 'date-fns/formatDistance'
import isToday from 'date-fns/isToday'

export function formatDate(date) {
  return format(date, 'yyyy/MM/dd')
}

export function formatDateFullTime(date) {
  try {
    return format(date, 'yyyy-MM-dd HH:mm:ss')
  } catch (error) {
    return ''
  }
}

export function formatDateFullToMinute(date) {
  try {
    return format(date, 'yyyy/MM/dd HH:mm')
  } catch (error) {
    return ''
  }
}

export function formatShortDate(date) {
  return format(date, 'HH:mm MM/dd')
}

export function formatFullHour(date) {
  return format(date, 'HH:mm:ss')
}

export function formatDateRelative(fromDate, toDate = new Date()) {
  return formatDistance(fromDate, toDate) + (isToday(toDate) ? ' ago' : '')
}
